import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { TAG_COLORS } from 'src/constants/tag';
import { useTranslation } from 'react-i18next';
import { IconButton, TextField } from '@mui/material';
import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
export const TagModalUnit = observer(_ref => {
  let data = _ref.data,
    handleEdit = _ref.handleEdit,
    handleDelete = _ref.handleDelete;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  const store = useStore();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDisabled = _useState2[0],
    setIsDisabled = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.unit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.name
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "Tag name",
    variant: "outlined",
    disabled: isDisabled,
    value: store.tags.getEditableTagById(data.id).name,
    onBlur: e => {
      if (e.target.value) console.log('');
    },
    onChange: e => {
      store.tags.changeEditableTag(data.id, 'name', e.target.value);
    },
    error: store.tags.getEditableTagById(data.id).name.trim().length === 0
  }), isDisabled && /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('admin_page.edit_tag_name'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip,
    onClick: () => setIsDisabled(false)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }))), !isDisabled && /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('admin_page.save_tag_name'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip,
    onClick: () => {
      if (store.tags.getEditableTagById(data.id).name.trim().length !== 0) {
        handleEdit(data.id);
        setIsDisabled(true);
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "double-check"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, TAG_COLORS.map((ci, ck) => /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.color, " ").concat(store.tags.getEditableTagById(data.id).color === TAG_COLORS[ck] ? 'active' : ''),
    style: {
      backgroundColor: TAG_COLORS[ck]
    },
    onClick: () => {
      store.tags.changeEditableTag(data.id, 'color', TAG_COLORS[ck]);
      handleEdit(data.id);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('admin_page.delete_tag'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip,
    onClick: () => handleDelete(data.id)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  })))));
});